module.exports = __webpack_public_path__ + "static/img/9e.224f986.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/9e.jpg
// module id = SlE0
// module chunks = 1